import React from 'react';
import { Modal, Button, Row, Col, Table } from 'react-bootstrap';
import * as moment from 'moment';
import { DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT, loaiTuyenSinhValue, objectLoaiTuyenSinh, trangThaiDotTuyenSinhValue, objectTrangThaiDotTuyenSinh, doiTuongValue, objectDoiTuong } from '../../../../../utils/define';
import { parseDoiTuongMienGiam } from '../dotTuyenSinh/DoiTuongMienGiamFields';

const ChiTietLopDaoTaoThucHanhModal = ({ isOpen, onClose, data, getChucDanhName }) => {
    if (!data) return null;

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    const chucDanhName = getChucDanhName(data.chucDanhIds || data.ChucDanhIds) || '';
    const chucDanhLower = chucDanhName.toLowerCase();
    const isBacSi = chucDanhLower.includes('bác sĩ') || chucDanhLower.includes('bac si');
    const isYSi = chucDanhLower.includes('y sĩ') || chucDanhLower.includes('y si');
    const isDieuDuong = chucDanhLower.includes('điều dưỡng') || chucDanhLower.includes('dieu duong');
    const isKTV = chucDanhLower.includes('ktv') || chucDanhLower.includes('kỹ thuật viên') || chucDanhLower.includes('ky thuat vien');

    return (
        <Modal
            show={isOpen}
            onHide={onClose}
            size="xl"
            backdrop="static"
            keyboard={false}
            centered
            style={{ zIndex: '9999' }}
        >
            <Modal.Header closeButton>
                <Modal.Title className="text-primary font-weight-bold">Chi tiết Tuyển sinh Đào tạo thực hành</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                <h5 className="text-info mb-3 border-bottom pb-2">Thông tin chung</h5>
                <Row className="mb-3">
                    <Col md={6}>
                        <p><strong>Tên khóa học:</strong> <span className="text-danger">{data.tenKhoaHoc || data.TenKhoaHoc}</span></p>
                        <p><strong>Loại tuyển sinh:</strong> <span className="badge badge-success">{getLabelFromEnum(data.loaiTuyenSinh ?? data.LoaiTuyenSinh, objectLoaiTuyenSinh, loaiTuyenSinhValue)}</span></p>
                        <p><strong>Trạng thái:</strong> <span className="badge badge-primary">{getLabelFromEnum(data.trangThaiDotTuyenSinh ?? data.TrangThaiDotTuyenSinh, objectTrangThaiDotTuyenSinh, trangThaiDotTuyenSinhValue)}</span></p>
                        <p><strong>Đối tượng:</strong> {getLabelFromEnum(data.doiTuongEnum ?? data.DoiTuongEnum, objectDoiTuong, doiTuongValue)}</p>
                        <p><strong>Chức danh:</strong> {chucDanhName}</p>
                        <p><strong>Đối tượng miễn giảm:</strong> {parseDoiTuongMienGiam(data.doiTuongMienGiam ?? data.DoiTuongMienGiam).map(x => x.tenDoiTuong).join(', ') || 'Không có'}</p>
                    </Col>
                    <Col md={6}>
                        <p><strong>Ngày khai giảng:</strong> {(data.ngayKhaiGiang || data.NgayKhaiGiang) ? moment(data.ngayKhaiGiang || data.NgayKhaiGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                        <p><strong>Ngày bắt đầu nhận hồ sơ:</strong> {(data.ngayBatDauNhanHoSo || data.NgayBatDauNhanHoSo) ? moment(data.ngayBatDauNhanHoSo || data.NgayBatDauNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                        <p><strong>Ngày kết thúc nhận hồ sơ:</strong> {(data.ngayKetThucNhanHoSo || data.NgayKetThucNhanHoSo) ? moment(data.ngayKetThucNhanHoSo || data.NgayKetThucNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                    </Col>
                </Row>

                {(isBacSi || isYSi || isDieuDuong || isKTV) && (
                    <>
                        <h5 className="text-info mb-3 border-bottom pb-2">Thời gian & Học phí theo đối tượng</h5>
                        <div className="table-responsive mb-3">
                            <Table bordered hover size="sm" className="text-center">
                                <thead className="bg-light">
                                    <tr>
                                        <th>Đối tượng</th>
                                        <th>Thời gian (Tháng)</th>
                                        <th>Học phí (VNĐ)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isBacSi && (
                                    <tr>
                                        <td className="font-weight-bold text-left">Bác sĩ</td>
                                        <td>{data.thoiGianBacSi || data.ThoiGianBacSi || '-'}</td>
                                        <td className="text-right text-danger">{(data.hocPhiBacSi != null || data.HocPhiBacSi != null) ? new Intl.NumberFormat('vi-VN').format(data.hocPhiBacSi ?? data.HocPhiBacSi) : '-'}</td>
                                    </tr>
                                    )}
                                    {isYSi && (
                                    <tr>
                                        <td className="font-weight-bold text-left">Y sĩ</td>
                                        <td>{data.thoiGianYSi || data.ThoiGianYSi || '-'}</td>
                                        <td className="text-right text-danger">{(data.hocPhiYSi != null || data.HocPhiYSi != null) ? new Intl.NumberFormat('vi-VN').format(data.hocPhiYSi ?? data.HocPhiYSi) : '-'}</td>
                                    </tr>
                                    )}
                                    {isDieuDuong && (
                                    <tr>
                                        <td className="font-weight-bold text-left">Điều dưỡng</td>
                                        <td>{data.thoiGianDieuDuong || data.ThoiGianDieuDuong || '-'}</td>
                                        <td className="text-right text-danger">{(data.hocPhiDieuDuong != null || data.HocPhiDieuDuong != null) ? new Intl.NumberFormat('vi-VN').format(data.hocPhiDieuDuong ?? data.HocPhiDieuDuong) : '-'}</td>
                                    </tr>
                                    )}
                                    {isKTV && (
                                    <tr>
                                        <td className="font-weight-bold text-left">KTV (Kỹ thuật viên)</td>
                                        <td>{data.thoiGianKTV || data.ThoiGianKTV || '-'}</td>
                                        <td className="text-right text-danger">{(data.hocPhiKTV != null || data.HocPhiKTV != null) ? new Intl.NumberFormat('vi-VN').format(data.hocPhiKTV ?? data.HocPhiKTV) : '-'}</td>
                                    </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </>
                )}

                <h5 className="text-info mb-3 border-bottom pb-2">Nội dung chi tiết</h5>
                <div className="mb-3">
                    <strong>Nội dung khóa học:</strong>
                    <div 
                        className="p-3 bg-light rounded mt-2" 
                        dangerouslySetInnerHTML={{ __html: data.noiDungKhoaHoc || data.NoiDungKhoaHoc || '<i>Chưa cập nhật</i>' }} 
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Đóng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ChiTietLopDaoTaoThucHanhModal;
